import { render, staticRenderFns } from "./tambahdalamprovinsi.vue?vue&type=template&id=11176e67&"
import script from "./tambahdalamprovinsi.vue?vue&type=script&lang=js&"
export * from "./tambahdalamprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports